<template>
  <div style="width: 100%;height: 100%">
    <div class="previewBox" :class="{abs:!hasMask}">


      <!--      SMS-->
      <div class="SMS" v-if="currentItem.type === 'SMS'">
        <div class="SMS_head">
          <div class="SMS_name"></div>
          <div class="SMS_phone">13811012099</div>
        </div>
        <div class="SMS_box">
          <div class="time_box">{{$t('message.commonUsage.today')}}12:00</div>
          <div class="content_box">{{ currentItem.detail }}</div>
        </div>
      </div>

      <!--      APP-->
      <div class="APP" v-if="currentItem.type === 'APP'">
        <div class="APP_title">
          <a-icon type="left"/>
          <h2>XXXXX</h2>
        </div>
        <div class="APP_time">
          10月27日 12:00:36
        </div>
        <div class="APP_box">
          <div style="font-weight: bolder;font-size: 16px;margin-bottom: 5px">{{ currentItem.app_push_title }}</div>
          <div>
            {{ currentItem.detail }}
          </div>
          <div style="color: skyblue;margin-top: 8px;">展开</div>
        </div>
      </div>

      <!--WeChat      -->
      <div class="WeChat" v-if="currentItem.type === 'WechatOA'">
        <div class="WeChat_title">
          <a-icon type="left"/>
          <h2>XXXXX</h2>
          <a-icon type="user"/>
        </div>
        <div class="WeChat_time">
          10月27日 12:00:36
        </div>
        <div class="WeChat_box">
          <div>{{ currentItem.detail }}</div>
          <div style="color: skyblue;margin-top: 8px;">展开</div>
        </div>
        <div v-if="previewItem.attachments" class="WeChat_attachement_box"
             style="background-color: #fff;margin-top: 24px;padding: 0;">
          <div v-for="(attachment,index) in previewItem.attachments" :key="index" class="preview_container">
            <div v-if="attachment.type === 'image'" class="preview_block">
              <img :src="attachment.url" alt="" class="image">
            </div>
            <div v-if="attachment.type === 'mpvideo'" class="preview_block" style="position: relative">
              <video :src="attachment.url"
                     style="width: 100%;height: 100%;object-fit: cover;"></video>
              <a-icon type="play-circle" style="position: absolute;top:50%;left:50%;transform:  translate(-50%,-50%);color:var(--main-color);font-size: 48px;"/>
            </div>

          </div>
        </div>
      </div>

      <!--      企业微信-->
      <div class="Enterprise" v-if="currentItem.type === '企业微信'">
        <div class="Enterprise_title">
          <a-icon type="left"/>
          <h2>XXXXX</h2>
          <a-icon type="user"/>
        </div>
        <div style="overflow-y: auto;height: 100%;">
          <div class="Enterprise_time">
            10月27日 12:00:36
          </div>
          <div class="Enterprise_box">
            <div>{{ currentItem.detail }}</div>
            <div style="color: skyblue;margin-top: 8px;">展开</div>
          </div>
          <div v-if="previewItem.attachments" class="Enterprise_box"
               style="background-color: #fff;margin-top: 24px;padding: 0;">
            <div v-for="(attachment,index) in previewItem.attachments" :key="index" class="preview_container">
              <div v-if="attachment.type === 'image'" class="preview_block">
                <img :src="attachment.url" alt="" class="image">
              </div>
              <div v-if="attachment.type === 'video'" class="preview_block" style="position: relative">
                <video :src="attachment.url"
                       style="width: 100%;height: 100%;object-fit: cover;"></video>
                <a-icon type="play-circle" style="position: absolute;top:50%;left:50%;transform:  translate(-50%,-50%);color:var(--main-color);font-size: 48px;"/>
              </div>
              <div v-if="attachment.type === 'link'" class="preview_block">
                <div class="link">
                  <div class="link-title">
                    {{ attachment.name }}
                  </div>
                  <div class="link-text">
                    {{ attachment.desc }}
                  </div>
                </div>
              </div>
              <div v-if="attachment.type === 'miniPro'" class="preview_block">
                <div class="miniPro">
                  <div class="miniPro-name">
                    {{ attachment.microAppObj.label }}
                  </div>
                  <div class="miniPro-title">
                    {{ attachment.name }}
                  </div>
                  <div class="miniPro-img">
                    <img :src="attachment.url" alt="" class="image">
                  </div>
                  <a-divider></a-divider>
                  <span class="miniPro-footer">
                    <a-icon type="link" style="color:skyblue"></a-icon>小程序
                  </span>
                </div>
              </div>

              <div v-if="attachment.type === 'docs'" class="preview_block">
                <div class="file">
                  <div class="file-main">
                    <div class="file-main-name">{{ attachment.name }}</div>
                    <div class="file-main-size">{{ attachment.size }}</div>
                  </div>
                  <div class="file-img">
                    <img :src="matchLogo(attachment.name)" alt="">
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!--      Email-->
      <div class="Email" v-if="currentItem.type === 'Email'">
        <iframe ref="emailIframe" :src="emailSrc" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </div>
    <div class="mask" v-if="hasMask" @click="$emit('cancel')"></div>
  </div>
</template>

<script>
import {matchFileLogo} from '@/utils/common'
export default {
  name: "previewBox",
  props: {
    previewItem: {
      type: Object,
      defalut: () => {
      }
    },
    hasMask: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentItem: {
        type: '',
        detail: ''
      },
      emailSrc:''
    }
  },
  methods:{
    matchLogo(name){
      const type = name.substring(name.lastIndexOf('.') + 1, name.length)
      return matchFileLogo(type)
    },
    setIframeContent(content) {
      const blob = new Blob([content], { type: 'text/html' })
      this.emailSrc = URL.createObjectURL(blob)
    }
  },
  watch: {
    previewItem: {
      handler(v) {
        console.log(v)
        this.currentItem = v
        if (v.type === 'Email') {
          this.setIframeContent(v.detail)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="less">
::-webkit-scrollbar {
  display: none !important;
}
.abs {
  position: absolute !important;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999998;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.previewBox {
  background-image: url(../../../assets/iphone.png);
  background-size: 100% 100%;
  position: fixed;
  z-index: 9999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 419px;
  height: 852px;
  text-align: center;
  padding: 90px 35px 40px 30px;

  .APP {
    &_title {

      display: flex;
      grid-gap: 115px;

      ::v-deep .anticon {
        line-height: 35px;
        font-size: 26px;
      }
    }

    &_time {
      font-weight: bolder;
      margin-bottom: 10px;
    }

    &_box {
      width: 100%;
      height: auto;
      background: #F2F2F2;

      border-radius: 8px 8px 8px 8px;
      text-align: left;
      padding: 16px;
      word-wrap: break-word;
    }
  }

  .WeChat {
    height:calc(100% - 40px);
    overflow:auto;

    &_title {

      display: flex;
      justify-content: space-between;

      ::v-deep .anticon {
        line-height: 35px;
        font-size: 26px;
      }
    }

    &_time {
      font-weight: bolder;
      margin-bottom: 10px;
    }

    &_box {
      width: 100%;
      height: auto;
      background: #F2F2F2;

      border-radius: 8px 8px 8px 8px;
      text-align: left;
      padding: 16px;
      word-wrap: break-word;
    }

    &_attachement_box {
      width: 100%;
      height: auto;
      background: #F2F2F2;

      border-radius: 8px 8px 8px 8px;
      text-align: left;
      padding: 16px;
      word-wrap: break-word;

      .preview_container {
        width: 100%;
        height: 100%;
        margin-top: 24px;

        .preview_block {
          background-color: #F2F2F2;
          width: 100%;
          height: 100%;
          padding: 15px;

          .image {
            max-height: 100%;
            max-width: 100%;
          }

          .file {
            display: flex;
            grid-gap: 5px;

            &-main {
              flex: 1;
              max-width: calc(100% - 50px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              &-name {
                font-size: 18px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }

              &-size {
                color: #ccc
              }
            }

            &-img {
              width: 50px;
              height: 50px;
              text-align: center;
              line-height: 50px;

              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
        }
      }
    }
  }

  .Enterprise {
    height:calc(100% - 40px);
    ::-webkit-scrollbar {
      display: none;
    }

    &_title {

      display: flex;
      justify-content: space-between;

      ::v-deep .anticon {
        line-height: 35px;
        font-size: 26px;
      }
    }

    &_time {
      font-weight: bolder;
      margin-bottom: 10px;
    }

    &_box {
      width: 100%;
      height: auto;
      background: #F2F2F2;

      border-radius: 8px 8px 8px 8px;
      text-align: left;
      padding: 16px;
      word-wrap: break-word;

      .preview_container {
        width: 100%;
        height: 100%;
        margin-top: 24px;

        .preview_block {
          background-color: #F2F2F2;
          width: 100%;
          height: 100%;
          padding: 15px;

          .image {
            max-height: 100%;
            max-width: 100%;
          }

          .link {
            width: 100%;
            height: 100%;

            &-title {
              width: 100%;
              font-size: 16px;
              font-weight: bolder;
            }

            &-text {
              width: 100%;

            }
          }

          .miniPro {
            &-name {
              font-size: 14px;
              color: #ccc
            }

            &-title {
              font-size: 28px;
              font-weight: bolder;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }

          .file {
            display: flex;
            grid-gap: 5px;

            &-main {
              flex: 1;
              max-width: calc(100% - 50px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              &-name {
                font-size: 18px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }

              &-size {
                color: #ccc
              }
            }

            &-img {
              width: 50px;
              height: 50px;
              text-align: center;
              line-height: 50px;

              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
        }
      }
    }

  }


  .SMS {
    &_head {
      height: 88px;
      border-bottom: 1px solid #DCDCDC;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &_name {
      width: 56px;
      height: 56px;
      background: #D9D9D9;
      border-radius: 50% 50%;
      margin-bottom: 4px;
    }

    &_phone {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.9);
    }

    &_box {
      .time_box {
        margin: 16px 0;
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.6);
      }

      .content_box {

        width: 280px;
        height: auto;
        background: #F2F2F2;
        border-radius: 8px 8px 8px 8px;
        text-align: left;
        padding: 16px;
        word-wrap: break-word;
      }
    }
  }

  .Email{
    width: 100%;
    height: 100%;
    iframe{
      width: 100%;
      height: 100%;
    }
  }
}

</style>